import React, { useState, useEffect, useRef } from 'react'
import { Box, Button, FormControl, IconButton, Stack, SvgIcon, TextField, Typography } from '@mui/material'


/**
 * AddNewQuestionDrawer is a UI component used to add a new question to the job application form.
 * It is a dialog with a text field for the user to input their question and two buttons, cancel and save.
 * When the user clicks the save button, the new question is added to the job application form.
 * @param {array} questions - array of questions to be displayed in the job application form
 * @param {function} setQuestions - function to update the state of the questions array
 * @param {number} qusIndex - index of the question to be updated in the questions array
 * @param {string} qus - the question to be updated in the questions array
 * @param {function} onClose - function to close the dialog
 * @returns A JSX element for the AddNewQuestionDrawer component
 */
const AddNewQuestionDrawer = ({ questions, setQuestions, qusIndex, qus, onClose }) => {
    const [newQus, setNewQus] = useState(qus ? qus : '');
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            const input = inputRef.current;
            const length = input.value.length;
            input.setSelectionRange(length, length);
        }
    }, []);
    // on save
    const handleSetQus = () => {
        // console.log(qusIndex)
        if (qusIndex) {
            const newQuestions = [...questions];
            newQuestions[qusIndex] = newQus;
            setQuestions(newQuestions);
            // console.log(newQuestions);
            onClose();
        } else {
            const newQuestions = [...questions, newQus];
            setQuestions(newQuestions);
            // console.log(newQuestions);
            onClose();
        }
    };

    return (
        <Box sx={{ width: 450 }} className="job-app-drawer-container" role="presentation" >
            {/* header */}
            <Box className="drawer-header">
                <Stack direction="row" alignItems={'center'} spacing={1}>
                    <IconButton onClick={() => onClose()}>
                        <SvgIcon>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M21.2391 12.7064L4.71739 12.7064L9.93478 17.6385C10.2609 17.9468 10.2609 18.4606 9.93478 18.7688C9.6087 19.0771 9.06522 19.0771 8.73913 18.7688L2.21739 12.5009C2.1087 12.3982 2 12.1927 2 11.9872C2 11.7817 2.1087 11.5761 2.21739 11.4734L8.73913 5.2055C8.84783 5.10275 9.06522 5 9.28261 5C9.5 5 9.71739 5.10275 9.82609 5.2055C10.1522 5.51376 10.1522 6.02752 9.82609 6.33578L4.6087 11.2679L21.1304 11.2679C21.5652 11.2679 22 11.5761 22 12.0899C22 12.6037 21.6739 12.7064 21.2391 12.7064Z" fill="white" />
                            </svg>
                        </SvgIcon>
                    </IconButton>

                    <Box>
                        <Typography className="title" sx={{ marginBottom: "0!important" }}>Add New Question</Typography>
                    </Box>
                </Stack>
            </Box>
            {/* Textfield */}
            <Box className="drawer-content">
                <FormControl fullWidth>
                    <TextField
                        label="Your Question"
                        size="small"
                        variant="outlined"
                        value={newQus}
                        onChange={(e) => setNewQus(e.target.value)}
                        multiline
                        autoFocus
                        inputRef={inputRef}
                    />
                </FormControl>
            </Box>
            {/* footer */}
            <Box className="drawer-footer">
                <Stack direction="row" spacing={2}>
                    <Button fullWidth size="large" className="cancel-btn" disableRipple disableElevation onClick={() => onClose()}>Cancel</Button>
                    <Button fullWidth variant="contained" size="large" className="update-btn" disableRipple disableElevation onClick={handleSetQus}>Save</Button>
                </Stack>
            </Box>
        </Box>
    )
}

export default AddNewQuestionDrawer
